import gql from "graphql-tag";

export const VIEWER_CAMPAIGNS_QUERY = gql`
  {
    Viewer {
      firstName
      lastName
      avatarImage
      activeStatus
      personalAccount {
        continuityReason
        isAccessible
        transferrableFunds {
          currency
          outstandingAmount {
            formatted(round: 0)
            centsAmount
          }
        }
        continuityPrevCampaign {
          id
          name
          photoImage
          url
          isViewerOwner
          amountRaised {
            formatted(round: 0)
          }
          goal {
            formatted(round: 0)
          }
        }
        amountRaised {
          formatted(round: 0)
        }
      }
      activeCampaign {
        id
        name
        photoImage
        url
        isViewerOwner
        amountRaised {
          formatted(round: 0)
        }
        daysOrHoursLeftLabel
        goal {
          formatted(round: 0)
        }
      }
      runningCampaigns {
        id
        name
        photoImage
        url
        amountRaised {
          formatted(round: 0)
        }
        daysOrHoursLeftLabel
        goal {
          formatted(round: 0)
        }
      }
      endedCampaigns {
        id
        name
        photoImage
        url
        amountRaised {
          formatted(round: 0)
        }
        daysOrHoursLeftLabel
        goal {
          formatted(round: 0)
        }
      }
    }
  }
`;
